const CreateDocumentsRequest = function() {
  return {
    documentFile: {
      fileName: "",
      file: null,
      mimeType: "png",
      size: 0
    },
    documentTypeCode: null,
    sourceType: null,
    sourceValue: null
  };
};

export default CreateDocumentsRequest;



// WEBPACK FOOTER //
// ./src/service/request/CreateDocumentsRequest.js